import React from "react";
import {ModalComponentType} from "./typings";

export const componentMap: {[key in ModalComponentType]?: {title: string, component: React.LazyExoticComponent<any>} | null} = {
    'email-form' : {
        title: 'Gửi email',
        component: React.lazy(() => import('./components/EmailForm')),
    },
}